export default __webpack_public_path__ + "static/media/illustrationCompanyDisabled.61c66a4d.svg";